require("./output/Sokoban.Main/index.js").main();



//////////////////
// WEBPACK FOOTER
// ./index.js
// module id = 279
// module chunks = 0